import * as React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const Seo = ({
  description = "", lang = "en", meta = [], title,
  imagePath = null, type = "website", twitterCard = "summary",
  articlePublishDate
}) => {

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
            title
            description
            social {
              twitter
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const metaTitle = title ? `${title} | ${defaultTitle}` : defaultTitle
  const siteUrl = process.env.NODE_ENV === "production" ? site.siteMetadata.siteUrl : "http://localhost:8000"
  const imageMeta = imagePath ? ["og:image", "image"].map((tag)=> { return { property: tag, content: `${siteUrl}${imagePath}` }}) : []
  const twitterImageMeta = imagePath ? [{ name: "twitter:image", content: `${siteUrl}${imagePath}` }] : []

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      defaultTitle={defaultTitle}
      titleTemplate={`%s | ${defaultTitle}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: type,
        },
        {
          name: `twitter:card`,
          content: twitterCard,
        },
        {
          name: `twitter:site`,
          content: `@${site.siteMetadata?.social?.twitter}`,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `article:published_time`,
          content: articlePublishDate
        }
      ].concat(imageMeta).concat(twitterImageMeta).concat(meta).filter((item)=> item.content)}
    />
  )
}

export default Seo
